<template>
  <div>
    <a-tabs>
      <a-tab-pane :tab="v.menu_name" v-for="v in list" :key="v.id">
        <a-table :pagination='false' :loading='listLoading' bordered :columns='columns' :data-source='v.children'>
          <template v-slot:action="{ record }">
            <a-button type="primary" @click='checkBnt(record)' :ghost="!record.select">{{!record.select ? "选择":"已选择"}}</a-button>
          </template>
        </a-table>
      </a-tab-pane>
    </a-tabs>
    <div class="s_flex_center m-t-10">
    <a-button type="primary" @click='confirm'>确定</a-button>
  </div>
  </div>
</template>

<script>
import { getBrandSaleMenu } from "@/api/salesman";
import { onMounted, reactive, ref, toRefs } from "@vue/runtime-core";
import { iscode } from "../../../../../utils/app";
import { message } from 'ant-design-vue';
const columns = [
  {
    title: "应用名称",
    dataIndex: "menu_name",
    key: "menu_name",
  },
  {
    title: "操作",
    key: "action",
    slots: { customRender: "action" },
  },
];
export default {
  name: "moduleSelect",
  props: {
    levelid: Number,
    selectList: {
      type: Array,
    }
  },
  setup(props,{emit}) {
      const state=reactive({
          selectList:[]
      })
    const list = ref([]);
    const initData = async () => {
      let result = await getBrandSaleMenu()
        .then((res) => res.data)
        .catch((error) => error);
      list.value = result.data;
      console.log(props.selectList);
      if (state.selectList || state.selectList.length > 0) {
        list.value.forEach((i) => {
          i.children.forEach((k) => {
            if (
              state.selectList.find((v) => {
                return k.id == v.id;
              })
            ) {
              k.select = true;
            }
          });
        });
      }
    };

    onMounted(() => {
      if (props.selectList) {
        state.selectList = JSON.parse(JSON.stringify(props.selectList));
      }
      initData();
    });

    //多选
    const checkBnt = (e) => {
      if (!e.select) {
          if(state.selectList.length==8){
              message.error("最多添加8个常用菜单")
              return
          }
        state.selectList.push(e);
      } else {
        var index = 0;
        state.selectList.forEach((v, k) => {
          if (v.id == e.id) {
            index = k;
          }
        });
        state.selectList.splice(index, 1);
      }
      e.select = !e.select;
    };
    //多选确认
    const confirm = () => {
      var list=state.selectList.map(v=>{
        if(!v.sort){
          v.sort=0
        }
        return v
      })
      emit("select", list);
    };
    return {
        ...toRefs(state),
      columns,
      list,
      checkBnt,
      confirm,
    };
  },
};
</script>